import {
  LOADING_PRISTINE,
  LOADING_STARTED,
  LOADING_COMPLETED_SUCCESS,
  LOADING_COMPLETED_FAILURE,
  INIT_DATA_MODULE,
  GET_HTTP_CONFIG,
  GET_BACKEND_URL,
  GET_IN_PROGRESS_STUDY_NAME,
  GET_IN_PROGRESS_STUDY_MODEL,
  GET_IN_PROGRESS_STUDY_NUMBER_OF_QUESTIONS,
  GET_IN_PROGRESS_STUDY_NUMBER_OF_ANSWERS,
  GET_IN_PROGRESS_STUDY_ANSWERS_AMOUNT,
  GET_IN_PROGRESS_STUDY_QUESTIONS_AMOUNT,
  GET_IN_PROGRESS_STUDY_QUESTIONS,
  GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_OBJ,
  GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX,
  GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX_ENGLISH,
  GET_IN_PROGRESS_STUDY_ADDITIONAL_CLASSIFICATION_QUESTION_OBJ,
  GET_IN_PROGRESS_STUDY_NUMBER_OF_SEGMENT_QUESTIONS,
  GET_IN_PROGRESS_STUDY_OPEN_ENDED_QUESTION,
  GET_IN_PROGRESS_STUDY_RESPONDENT_ORIENTATION,
  GET_IN_PROGRESS_STUDY_RATING_SCALE_NUMBER_OPTIONS,
  GET_IS_CURRENT_ROUTE_PART_OF_EDIT_GROUP,
  GET_OUTGOING_STUDY_OBJ,
  SET_CATEGORIES_STATE,
  SET_STUDIES_OF_USER,
  SET_UPDATE_STUDY_STATE,
  SET_GET_STUDY_STATE,
  SET_DELETE_STUDY_STATE,
  SET_IN_PROGRESS_STUDY_NAME,
  SET_IN_PROGRESS_STUDY_MODE,
  SET_IN_PROGRESS_STUDY_MODEL,
  SET_IN_PROGRESS_STUDY_AGREED_TO_TERMS,
  SET_IN_PROGRESS_STUDY_QUESTIONS_TEXT,
  SET_IN_PROGRESS_STUDY_ANSWERS_OF_QUESTION_N,
  SET_IN_PROGRESS_STUDY_REJECT_RESPONDENT_ID_QUESTION,
  SET_IN_PROGRESS_STUDY_OPEN_ENDED_QUESTION,
  SET_IN_PROGRESS_STUDY_RESPONDENT_ORIENTATION,
  SET_IN_PROGRESS_STUDY_RATING_SCALE_OBJ,
  SET_IN_PROGRESS_STUDY_FINAL_THOUGHTS,
  PUSH_IN_PROGRESS_STUDY_SEGMENT_QUESTION,
  REPLACE_IN_PROGRESS_STUDY_SEGMENT_QUESTION_AT_INDEX,
  DELETE_IN_PROGRESS_STUDY_SEGMENT_QUESTION_AT_INDEX,
  PUSH_IN_PROGRESS_STUDY_KEYWORD,
  SPLICE_IN_PROGRESS_STUDY_KEYWORD,
  SET_IN_PROGRESS_STUDY_SERVICE_TYPE,
  SET_IN_PROGRESS_STUDY_AGREED_TO_TERMS_FINAL,
  SET_STUDY_SOURCING_METHOD,
  SET_STUDY_MAX_PARTICIPANTS,
  SET_STUDY_PUBLISHED,
  SET_SURVEY_QUALIFICATIONS,
  SET_SURVEY_SELECTED_QUALIFICATIONS,
  SET_SURVEY_UPDATE_SELECTED_QUALIFICATIONS_STATE,
  A_DATA_MODULE_PER_ROUTE_ACTIONS,
  LOAD_STUDIES_OF_USER,
  LOAD_SURVEY_QUALIFICATIONS,
  UPDATE_SURVEY_SELECTED_QUALIFICATIONS,
  UPDATE_STUDY,
  GET_STUDY,
  DELETE_STUDY,
  GET_DOES_STUDY_NEED_TO_BE_LOADED,
  GET_STUDIES_OF_USER,
  GET_COPYRIGHT_TEXT,
  GET_CURRENT_ROUTE,
  STUDY_MODE_4,
  R_NAME_CREATE_A_STUDY,
  GET_IS_IN_PROGRESS_STUDY_UPDATING,
  R_NAME_RESULTS,
  R_NAME_MANAGE_STUDY_CHOOSE_SOURCING_METHOD,
  SET_COUNTRIES,
  LOAD_COUNTRIES,
  RESET_SELECTED_QUALIFICATIONS,
  SET_RESET_SELECTED_QUALIFICATIONS,
  SET_PUBLIC_STUDY_INFO,
  LOAD_PUBLIC_STUDY_INFO,
  SET_IN_PROGRESS_STUDY_ASKS_LINKER,
  SET_PURCHASES_OF_USER,
  LOAD_PURCHASES_OF_USER,
  GET_PURCHASES_OF_USER,
  R_NAME_PURCHASE,
  R_NAME_PURCHASE_FLASH,
  GET_IN_PROGRESS_STUDY_LANGUAGE,
  SET_IN_PROGRESS_STUDY_LANGUAGE,
  SET_IN_PROGRESS_STUDY_STUDENT,
  RESET_SURVEY_QUALIFICATIONS,
  SET_TELL_US_WHO_YOU_ARE,
  SET_STUDY_PRIVATE,
  SET_IN_PROGRESS_PRESENTATION_MEDIA,
  GET_IN_PROGRESS_PRESENTATION_MEDIA,
  SET_IN_PROGRESS_POST_PRESENTATION_MEDIA,
  GET_IN_PROGRESS_POST_PRESENTATION_MEDIA,
  GET_IN_PROGRESS_STUDY_PRE_OPTIONAL_QUESTION,
  SET_IN_PROGRESS_STUDY_PRE_OPTIONAL_QUESTION,
} from "../services/constants";
import http from "../services/axios";
import {
  studyModelFactory,
  incomingStudyMapper,
  numberToEnglish,
  selectedQualificationsModel,
  formatDate,
} from "../services/utilities";

const store = {
  state: {
    categories: {
      loadingState: LOADING_PRISTINE,
      data: [],
      error: null,
    },
    updateStudyState: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    getStudyState: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    deleteStudyState: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    inProgressStudy: studyModelFactory(STUDY_MODE_4),
    dashboard: {
      categoryId: -1,
    },
    studies: {
      loadingState: LOADING_PRISTINE,
      data: [],
      error: null,
    },
    purchases: {
      loadingState: LOADING_PRISTINE,
      data: [],
      error: null,
    },
    qualifications: {
      loadingState: LOADING_PRISTINE,
      data: [],
      error: null,
    },
    // selectedQualifications: {
    //   "countryLanguageID": 9,
    //   "qualifications": [],
    //   "quota": -1,
    //   "studyID": -1
    // },
    selectedQualifications: selectedQualificationsModel(),
    updateSelectedQualifications: {
      loadingState: LOADING_PRISTINE,
      data: [],
      error: null,
    },
    countries: {
      loadingState: LOADING_PRISTINE,
      data: [],
      error: null,
    },
    publicStudyInfo: {
      loadingState: LOADING_PRISTINE,
      data: [],
      error: null,
    },
    inProgressStudyUserTellUsWhoYouAre: "",
  },
  getters: {
    [GET_IN_PROGRESS_STUDY_NAME](state) {
      return state.inProgressStudy.name;
    },
    [GET_IN_PROGRESS_STUDY_LANGUAGE](state) {
      return state.inProgressStudy.language;
    },
    [GET_IN_PROGRESS_STUDY_QUESTIONS](state) {
      return state.inProgressStudy.questions.map((question, index) => {
        question.name = `Question ${index + 1}`;
        return question;
      });
    },
    [GET_IN_PROGRESS_STUDY_MODEL](state) {
      return state.inProgressStudy.meta.gridMode;
    },
    [GET_IN_PROGRESS_STUDY_NUMBER_OF_QUESTIONS](state, getters) {
      let modeDimensions = String(getters[GET_IN_PROGRESS_STUDY_MODEL]).split("x");
      return Number(modeDimensions[0]);
    },
    [GET_IN_PROGRESS_STUDY_NUMBER_OF_ANSWERS](state, getters) {
      let modeDimensions = String(getters[GET_IN_PROGRESS_STUDY_MODEL]).split("x");
      return Number(modeDimensions[1]);
    },
    [GET_IN_PROGRESS_STUDY_ANSWERS_AMOUNT](state, getters) {
      return numberToEnglish(getters[GET_IN_PROGRESS_STUDY_NUMBER_OF_ANSWERS]);
    },
    [GET_IN_PROGRESS_STUDY_QUESTIONS_AMOUNT](state, getters) {
      return numberToEnglish(getters[GET_IN_PROGRESS_STUDY_NUMBER_OF_QUESTIONS]);
    },
    [GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX](state, getters) {
      const params = getters[GET_CURRENT_ROUTE].params;
      if (params.n) {
        const n = params.n;
        if (!Number.isNaN(n)) {
          return Number(n) - 1;
        }
      }
      return -1;
    },
    [GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX_ENGLISH](state, getters) {
      const index = getters[GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX];
      let str = "";
      switch (index) {
        case 0:
          str += "first";
          break;
        case 1:
          str += "second";
          break;
        case 2:
          str += "third";
          break;
        case 3:
          str += "fourth";
          break;
        case 4:
          str += "fifth";
          break;
        case 5:
          str += "sixth";
          break;
      }
      return str;
    },
    [GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_OBJ](state, getters) {
      const i = getters[GET_IN_PROGRESS_STUDY_CURRENT_QUESTION_INDEX];
      if (i > -1) {
        const questionObj = state.inProgressStudy.questions[i];
        if (questionObj) {
          return {
            name: `Question ${i + 1}/${state.inProgressStudy.questions.length}: ${
              questionObj.text
            }`.toUpperCase(),
            answers: questionObj.answers.map((answer, index) => {
              answer.name = `Answer ${index + 1}`;
              return answer;
            }),
          };
        }
      }
      return null;
    },
    [GET_IN_PROGRESS_STUDY_NUMBER_OF_SEGMENT_QUESTIONS](state) {
      return state.inProgressStudy.segmentQuestions.length;
    },
    [GET_IN_PROGRESS_STUDY_ADDITIONAL_CLASSIFICATION_QUESTION_OBJ](state) {
      const obj = state.inProgressStudy.additionalClassificationQuestion;
      return {
        question: {
          text: obj.question.text,
          placeholder: "How often do you buy this product?",
        },
        answers: obj.answers.map((answer, index, arr) => {
          const answerClone = {
            text: answer.text,
          };
          answerClone.required = index === arr.length - 1;
          switch (index) {
            case 1:
              answerClone.placeholder = "weekly";
              break;
            case 2:
              answerClone.placeholder = "monthly";
              break;
            case 3:
              answerClone.placeholder = "yearly";
              break;
            default:
              answerClone.placeholder = "daily";
              break;
          }
          return answerClone;
        }),
      };
    },
    [GET_IN_PROGRESS_STUDY_OPEN_ENDED_QUESTION](state) {
      return {
        question: state.inProgressStudy.openEndedQuestion,
        placeholder: "Write your question here",
      };
    },
    [GET_IN_PROGRESS_STUDY_PRE_OPTIONAL_QUESTION](state) {
      return {
        question: state.inProgressStudy.preOptionalQuestion,
        placeholder: "Write your question here",
      };
    },
    [GET_IN_PROGRESS_PRESENTATION_MEDIA](state) {
      return state.inProgressStudy.presentationMedia;
    },
    [GET_IN_PROGRESS_POST_PRESENTATION_MEDIA](state) {
      return state.inProgressStudy.postPresentationMedia;
    },
    [GET_IN_PROGRESS_STUDY_RESPONDENT_ORIENTATION](state) {
      return state.inProgressStudy.respondentOrientation;
    },
    [GET_IN_PROGRESS_STUDY_RATING_SCALE_NUMBER_OPTIONS]() {
      return [5, 7, 9];
    },
    [GET_IS_IN_PROGRESS_STUDY_UPDATING](state) {
      return state.updateStudyState.loadingState === LOADING_STARTED;
    },
    [GET_COPYRIGHT_TEXT]() {
      const copyrightYear = new Date().getFullYear();
      return `All rights reserved to Big Mind ${copyrightYear} © | Website Design: Veev | Development: Sifra Digital`;
    },
    [GET_STUDIES_OF_USER](state) {
      return state.studies.data.map((study) => {
        let dateCreated = `${formatDate(new Date(study.dateCreated))}`;

        let routeName = "";
        if (study.published) {
          if (study.sourcingMethod) {
            routeName = R_NAME_RESULTS;
          } else {
            routeName = R_NAME_MANAGE_STUDY_CHOOSE_SOURCING_METHOD;
          }
        } else {
          routeName = R_NAME_CREATE_A_STUDY;
        }
        return {
          study,
          derived: {
            dateCreated: dateCreated,
            tags: study.tags ? study.tags.split(",") : [],
          },
          route: {
            name: routeName,
            params: {
              id: study.id,
            },
          },
        };
      });
      // return []
    },
    [GET_PURCHASES_OF_USER](state) {
      return state.purchases.data.map((purchase) => {
        let dateCreated = `${formatDate(new Date(purchase.study.dateCreated))}`;

        let route = {
          name: purchase.type === "full" ? R_NAME_PURCHASE : R_NAME_PURCHASE_FLASH,
          params: {
            id: purchase.study.id,
          },
        };

        return {
          purchase,
          derived: {
            dateCreated: dateCreated,
            tags: purchase.study.tags ? purchase.study.tags.split(",") : [],
          },
          route: route,
        };
      });
    },
    [GET_OUTGOING_STUDY_OBJ](state, getters, rootState) {
      const localObj = state.inProgressStudy;
      const obj = {
        id: localObj.meta.id,
        surveyParamaters: {
          id: localObj.meta.id,
          asksLinker: localObj.asksLinker,
          questions: localObj.questions.map((question) => {
            return {
              question: question.text,
              answers: question.answers.map((answer) => {
                return {
                  answer: answer.text,
                };
              }),
            };
          }),
          segmentQuestions: localObj.segmentQuestions,
          optionalQuestion: localObj.openEndedQuestion,
          optionalPreQuestion: localObj.preOptionalQuestion,
          preMediaQuestions: localObj.presentationMedia.preMediaQuestions,
          prePresentation: localObj.presentationMedia.prePresentation,
          postMediaQuestions: localObj.postPresentationMedia.postMediaQuestions,
          postPresentation: localObj.postPresentationMedia.postPresentation,
          studyInfo: localObj.respondentOrientation,
          ratingQuestions: localObj.ratingQuestions,
          name: localObj.name,
          language: localObj.language,
          maxRating: localObj.maxRating,
        },
        tags: localObj.keywords.map((keyword) => {
          return {
            keyword: keyword,
          };
        }),
        studyPurpose: localObj.finalThoughts,
        hidden: localObj.hidden,
        studyModel: localObj.meta.gridMode,
        sourcingMethod: localObj.sourcingMethod,
        maxParticipants: localObj.maxParticipants,
        published: localObj.published,
        student: localObj.student,
      };
      const userData = rootState.userModule.user.data;
      if (userData) {
        obj.userID = userData.id;
      }
      return obj;
    },
    [GET_DOES_STUDY_NEED_TO_BE_LOADED](state, getters) {
      if (getters[GET_IS_CURRENT_ROUTE_PART_OF_EDIT_GROUP]) {
        return Number(getters[GET_CURRENT_ROUTE].params.id) !== state.inProgressStudy.meta.id;
      }
      return false;
    },
  },
  mutations: {
    [SET_TELL_US_WHO_YOU_ARE](state, payload) {
      state.inProgressStudyUserTellUsWhoYouAre = payload;
    },
    [SET_COUNTRIES](state, payload) {
      state.countries = payload;
    },
    [SET_CATEGORIES_STATE](state, payload) {
      state.categories = payload;
    },
    [SET_UPDATE_STUDY_STATE](state, payload) {
      state.updateStudyState = payload;
    },
    [SET_GET_STUDY_STATE](state, payload) {
      state.getStudyState = payload;
    },
    [SET_DELETE_STUDY_STATE](state, payload) {
      state.deleteStudyState = payload;
    },
    [SET_IN_PROGRESS_STUDY_NAME](state, payload) {
      state.inProgressStudy.name = payload;
    },
    [SET_IN_PROGRESS_STUDY_LANGUAGE](state, payload) {
      state.inProgressStudy.language = payload;
    },
    [SET_IN_PROGRESS_STUDY_AGREED_TO_TERMS](state, payload) {
      state.inProgressStudy.agreedToTerms = payload;
    },
    [SET_IN_PROGRESS_STUDY_MODE](state, payload) {
      state.inProgressStudy.meta.gridMode = payload;
    },
    [SET_IN_PROGRESS_STUDY_MODEL](state, payload) {
      state.inProgressStudy = payload;
    },
    [SET_IN_PROGRESS_STUDY_QUESTIONS_TEXT](state, payload) {
      state.inProgressStudy.questions = state.inProgressStudy.questions.map((question, index) => {
        if (payload[index]) {
          question.text = payload[index].text;
        }
        return question;
      });
    },
    [SET_IN_PROGRESS_STUDY_ANSWERS_OF_QUESTION_N](state, payload) {
      const i = payload.i;
      const payloadAnswers = payload.answers;
      let answersOfQuestion = state.inProgressStudy.questions[i].answers;
      answersOfQuestion = answersOfQuestion.map((answer, index) => {
        answer.text = payloadAnswers[index].text;
        return answer;
      });
    },
    [PUSH_IN_PROGRESS_STUDY_SEGMENT_QUESTION](state, payload) {
      state.inProgressStudy.segmentQuestions.push(payload);
    },
    [REPLACE_IN_PROGRESS_STUDY_SEGMENT_QUESTION_AT_INDEX](state, payload) {
      state.inProgressStudy.segmentQuestions.splice(payload.index, 1, payload.segmentQuestion);
    },
    [DELETE_IN_PROGRESS_STUDY_SEGMENT_QUESTION_AT_INDEX](state, payload) {
      state.inProgressStudy.segmentQuestions.splice(payload.index, 1);
    },
    [SET_IN_PROGRESS_STUDY_REJECT_RESPONDENT_ID_QUESTION](state, payload) {
      state.inProgressStudy.rejectRespondentIdQuestion = payload;
    },
    [SET_IN_PROGRESS_STUDY_OPEN_ENDED_QUESTION](state, payload) {
      state.inProgressStudy.openEndedQuestion = payload;
    },
    [SET_IN_PROGRESS_STUDY_PRE_OPTIONAL_QUESTION](state, payload) {
      state.inProgressStudy.preOptionalQuestion = payload;
    },
    [SET_IN_PROGRESS_PRESENTATION_MEDIA](state, payload) {
      state.inProgressStudy.presentationMedia = payload;
    },
    [SET_IN_PROGRESS_POST_PRESENTATION_MEDIA](state, payload) {
      state.inProgressStudy.postPresentationMedia = payload;
    },
    [SET_IN_PROGRESS_STUDY_RESPONDENT_ORIENTATION](state, payload) {
      state.inProgressStudy.respondentOrientation = payload;
    },
    [SET_IN_PROGRESS_STUDY_RATING_SCALE_OBJ](state, payload) {
      state.inProgressStudy.ratingQuestions = payload.questions;
      state.inProgressStudy.maxRating = payload.scale;
    },
    [SET_IN_PROGRESS_STUDY_FINAL_THOUGHTS](state, payload) {
      state.inProgressStudy.finalThoughts = payload;
    },
    [SET_IN_PROGRESS_STUDY_STUDENT](state, payload) {
      state.inProgressStudy.student = payload;
    },
    [PUSH_IN_PROGRESS_STUDY_KEYWORD](state, payload) {
      state.inProgressStudy.keywords.push(payload);
    },
    [SPLICE_IN_PROGRESS_STUDY_KEYWORD](state, index) {
      state.inProgressStudy.keywords.splice(index, 1);
    },
    [SET_IN_PROGRESS_STUDY_SERVICE_TYPE](state, payload) {
      state.inProgressStudy.serviceType = payload;
    },
    [SET_IN_PROGRESS_STUDY_AGREED_TO_TERMS_FINAL](state, payload) {
      state.inProgressStudy.agreeToTermsFinal = payload;
    },
    [SET_IN_PROGRESS_STUDY_ASKS_LINKER](state, payload) {
      state.inProgressStudy.asksLinker = payload;
    },
    [SET_STUDY_SOURCING_METHOD](state, payload) {
      state.inProgressStudy.sourcingMethod = payload;
    },
    [SET_STUDY_PRIVATE](state, payload) {
      state.inProgressStudy.hidden = payload;
    },
    [SET_STUDY_MAX_PARTICIPANTS](state, payload) {
      state.inProgressStudy.maxParticipants = payload;
    },
    [SET_STUDY_PUBLISHED](state, payload) {
      state.inProgressStudy.published = payload;
    },
    [SET_STUDIES_OF_USER](state, payload) {
      state.studies = payload;
    },
    [SET_PURCHASES_OF_USER](state, payload) {
      state.purchases = payload;
    },
    [SET_SURVEY_QUALIFICATIONS](state, payload) {
      state.qualifications = payload;
    },
    [RESET_SURVEY_QUALIFICATIONS](state, payload) {
      state.qualifications = {
        loadingState: LOADING_PRISTINE,
        data: [],
        error: null,
      };
    },
    [SET_SURVEY_SELECTED_QUALIFICATIONS](state, payload) {
      state.selectedQualifications = Object.assign({}, state.selectedQualifications, payload);
    },
    [SET_SURVEY_UPDATE_SELECTED_QUALIFICATIONS_STATE](state, payload) {
      state.updateSelectedQualifications = payload;
    },
    [SET_RESET_SELECTED_QUALIFICATIONS](state) {
      state.selectedQualifications = selectedQualificationsModel();
    },
    [SET_PUBLIC_STUDY_INFO](state, payload) {
      state.publicStudyInfo = payload;
    },
  },
  actions: {
    [LOAD_STUDIES_OF_USER]: (context) => {
      context.commit(SET_STUDIES_OF_USER, {
        loadingState: LOADING_STARTED,
        data: context.state.studies.data,
        error: context.state.studies.error,
      });

      return http
        .get(context.getters[GET_BACKEND_URL](`studies/user`), context.getters[GET_HTTP_CONFIG])
        .then((response) => {
          context.commit(SET_STUDIES_OF_USER, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: response.data,
            error: null,
          });
        })
        .catch((err) => {
          console.error(err);
          context.commit(SET_STUDIES_OF_USER, {
            loadingState: LOADING_COMPLETED_FAILURE,
            data: [],
            error: err,
          });
        });
    },
    [LOAD_PURCHASES_OF_USER]: (context) => {
      context.commit(SET_PURCHASES_OF_USER, {
        loadingState: LOADING_STARTED,
        data: context.state.purchases.data,
        error: context.state.purchases.error,
      });

      return http
        .get(
          context.getters[GET_BACKEND_URL](`users/current/purchases`),
          context.getters[GET_HTTP_CONFIG]
        )
        .then((response) => {
          context.commit(SET_PURCHASES_OF_USER, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: response.data,
            error: null,
          });
        })
        .catch((err) => {
          console.error(err);
          context.commit(SET_PURCHASES_OF_USER, {
            loadingState: LOADING_COMPLETED_FAILURE,
            data: [],
            error: err,
          });
        });
    },
    [UPDATE_STUDY]: (context) => {
      context.commit(SET_UPDATE_STUDY_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.updateStudyState.data,
        error: context.state.updateStudyState.error,
      });

      return http
        .post(
          context.getters[GET_BACKEND_URL](`v2/studies`),
          context.getters[GET_OUTGOING_STUDY_OBJ],
          context.getters[GET_HTTP_CONFIG]
        )
        .then((response) => {
          context.commit(SET_IN_PROGRESS_STUDY_MODEL, incomingStudyMapper(response.data));
          return context.dispatch(LOAD_STUDIES_OF_USER).then(() => {
            context.commit(SET_UPDATE_STUDY_STATE, {
              loadingState: LOADING_COMPLETED_SUCCESS,
              data: response.data,
              error: null,
            });
          });
        })
        .catch((err) => {
          console.error(err);
          context.commit(SET_UPDATE_STUDY_STATE, {
            loadingState: LOADING_COMPLETED_FAILURE,
            data: null,
            error: err,
          });
        });
    },
    [GET_STUDY]: (context, studyId) => {
      context.commit(SET_GET_STUDY_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.updateStudyState.data,
        error: context.state.updateStudyState.error,
      });

      return http
        .get(
          context.getters[GET_BACKEND_URL](`v2/studies/${studyId}`),
          context.getters[GET_HTTP_CONFIG]
        )
        .then((response) => {
          context.commit(SET_GET_STUDY_STATE, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: response.data,
            error: null,
          });
          context.commit(SET_IN_PROGRESS_STUDY_MODEL, incomingStudyMapper(response.data));
        })
        .catch((err) => {
          console.error(err);
          context.commit(SET_GET_STUDY_STATE, {
            loadingState: LOADING_COMPLETED_FAILURE,
            data: null,
            error: err,
          });
        });
    },
    [DELETE_STUDY]: (context, studyId) => {
      context.commit(SET_DELETE_STUDY_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.deleteStudyState.data,
        error: context.state.deleteStudyState.error,
      });

      return http
        .put(
          context.getters[GET_BACKEND_URL](`studies/delete/${studyId}`),
          null,
          context.getters[GET_HTTP_CONFIG]
        )
        .then((response) => {
          return context.dispatch(LOAD_STUDIES_OF_USER).then(() => {
            context.commit(SET_DELETE_STUDY_STATE, {
              loadingState: LOADING_COMPLETED_SUCCESS,
              data: response.data,
              error: null,
            });
          });
        })
        .catch((err) => {
          console.error(err);
          context.commit(SET_DELETE_STUDY_STATE, {
            loadingState: LOADING_COMPLETED_FAILURE,
            data: null,
            error: err,
          });
        });
    },
    [LOAD_SURVEY_QUALIFICATIONS]: (context, id) => {
      context.commit(SET_SURVEY_QUALIFICATIONS, {
        loadingState: LOADING_STARTED,
        data: context.state.qualifications.data,
        error: context.state.qualifications.error,
      });

      return http
        .get(
          context.getters[GET_BACKEND_URL](`lucid/data/qualifications/${id}`),
          context.getters[GET_HTTP_CONFIG]
        )
        .then((response) => {
          console.log(response);
          context.commit(SET_SURVEY_QUALIFICATIONS, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: response.data,
            error: null,
          });
        })
        .catch((err) => {
          console.error(err);
          context.commit(SET_SURVEY_QUALIFICATIONS, {
            loadingState: LOADING_COMPLETED_FAILURE,
            data: [],
            error: err,
          });
        });
    },
    [LOAD_PUBLIC_STUDY_INFO]: (context, id) => {
      context.commit(SET_PUBLIC_STUDY_INFO, {
        loadingState: LOADING_STARTED,
        data: context.state.publicStudyInfo.data,
        error: context.state.publicStudyInfo.error,
      });

      return http
        .get(
          context.getters[GET_BACKEND_URL](`v2/studies/${id}/public`),
          context.getters[GET_HTTP_CONFIG]
        )
        .then((response) => {
          context.commit(SET_PUBLIC_STUDY_INFO, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: response.data,
            error: null,
          });
        })
        .catch((err) => {
          console.error(err);
          context.commit(SET_PUBLIC_STUDY_INFO, {
            loadingState: LOADING_COMPLETED_FAILURE,
            data: [],
            error: err,
          });
        });
    },
    [UPDATE_SURVEY_SELECTED_QUALIFICATIONS]: (context) => {
      context.commit(SET_SURVEY_UPDATE_SELECTED_QUALIFICATIONS_STATE, {
        loadingState: LOADING_STARTED,
        data: context.state.qualifications.data,
        error: context.state.qualifications.error,
      });

      const studyId = context.state.inProgressStudy.meta.id;
      const postBody = context.state.selectedQualifications;
      return http
        .post(
          context.getters[GET_BACKEND_URL](`studies/${studyId}/lucid/create`),
          postBody,
          context.getters[GET_HTTP_CONFIG]
        )
        .then((response) => {
          context.commit(SET_SURVEY_UPDATE_SELECTED_QUALIFICATIONS_STATE, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: response.data,
            error: null,
          });
        })
        .catch((err) => {
          console.error(err);
          context.commit(SET_SURVEY_UPDATE_SELECTED_QUALIFICATIONS_STATE, {
            loadingState: LOADING_COMPLETED_FAILURE,
            data: [],
            error: err,
          });
        });
    },
    [LOAD_COUNTRIES]: (context) => {
      context.commit(SET_COUNTRIES, {
        loadingState: LOADING_STARTED,
        data: [],
        error: null,
      });

      return http
        .get(context.getters[GET_BACKEND_URL](`data/countries`), context.getters[GET_HTTP_CONFIG])
        .then((response) => {
          context.commit(SET_COUNTRIES, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: response.data,
            error: null,
          });
        })
        .catch((err) => {
          console.error(err);
          context.commit(SET_COUNTRIES, {
            loadingState: LOADING_COMPLETED_FAILURE,
            data: [],
            error: err,
          });
        });
    },
    [INIT_DATA_MODULE]: (context) => {
      const actions = [];
      actions.push(context.dispatch(LOAD_COUNTRIES));
      if (context.getters[GET_DOES_STUDY_NEED_TO_BE_LOADED]) {
        actions.push(context.dispatch(GET_STUDY, context.getters[GET_CURRENT_ROUTE].params.id));
      }
      return Promise.all(actions);
    },
    [A_DATA_MODULE_PER_ROUTE_ACTIONS]: (context, toRoute) => {
      const actions = [];
      return Promise.all(actions);
    },
    [RESET_SELECTED_QUALIFICATIONS]: (context) => {
      context.commit(SET_RESET_SELECTED_QUALIFICATIONS);
    },
  },
};

export default store;
export const dataModule = store;
